export const PENDING_REFERRAL_CODE_STORAGE_KEY = "finu.pending_referral_code";

export const getReferralCodeFromSearch = (search = "") => {
  const code = new URLSearchParams(search).get("ref")?.trim();
  return code || "";
};

export const storePendingReferralCode = (code) => {
  if (!code || typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(PENDING_REFERRAL_CODE_STORAGE_KEY, code);
  } catch {
    // Storage can be unavailable in private or embedded browser contexts.
  }
};

export const getPendingReferralCode = () => {
  if (typeof window === "undefined") return "";

  try {
    return window.sessionStorage.getItem(PENDING_REFERRAL_CODE_STORAGE_KEY) || "";
  } catch {
    return "";
  }
};

export const clearPendingReferralCode = () => {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.removeItem(PENDING_REFERRAL_CODE_STORAGE_KEY);
  } catch {
    // Non-critical cleanup.
  }
};
